export var PixelType;
(function (PixelType) {
    PixelType[PixelType["STATIC"] = 0] = "STATIC";
    PixelType[PixelType["UNIVERSAL"] = 1] = "UNIVERSAL";
})(PixelType || (PixelType = {}));
/**
 * Install-source discriminator for Universal pixels. NONE for direct HTML
 * installs (the default); SHOPIFY for pixels installed via the Shopify
 * Customer Events integration. Only meaningful when `PixelType.UNIVERSAL` —
 * STATIC pixels should always be NONE.
 */
export var PixelSubtype;
(function (PixelSubtype) {
    PixelSubtype[PixelSubtype["NONE"] = 0] = "NONE";
    PixelSubtype[PixelSubtype["SHOPIFY"] = 1] = "SHOPIFY";
})(PixelSubtype || (PixelSubtype = {}));
//# sourceMappingURL=types.js.map